module.exports = __webpack_public_path__ + "24573b69.png";